export default {
    'ONBOARDING.OPTION.HUB.TEAM': 'Hub',
    'ONBOARDING.OPTION.HUB.TITLE': 'Ajouter un hub',
    'ONBOARDING.OPTION.TEAMS.TITLE': 'Hubs',
    'ONBOARDING.OPTION.TEAMS.ASIDE': 'Vous pouvez toujours modifier vos hubs ici ou passer à l\'étape suivante.',
    'ONBOARDING.OPTION.TEAMS.FORM.TITLE': 'Nom du hub',
};
